export const AUTH_RECRUITER_EMAIL_LOGIN = "/api/v1/auth/login/recruiter/email";

export const AUTH_RECRUITER_GOOGLE_LOGIN =
  "/api/v1/auth/login/recruiter/google";

export const AUTH_ME = "/api/v1/auth/me/recruiter";

/** Recruiter jobs (used with mainUrl: mainUrl + path => /api/v1/recruiter/jobs) */
export const RECRUITER_JOBS_BASE = "/v1/recruiter/jobs";

/** Recruiter assessments base (interviews, mock-tests, coding-interviews) */
export const RECRUITER_ASSESSMENTS_BASE = "/v1/recruiter/assessments";

/** Recruiter assessments – available MCQ categories (GET, recruiter auth) */
export const RECRUITER_ASSESSMENTS_AVAILABLE_CATEGORIES =
  "/v1/recruiter/assessments/available-categories";

/** Recruiter invitations – combined list (interviews, job posts, mock tests, resume sortings) */
export const RECRUITER_INVITATIONS_BASE = "/v1/recruiter/invitations";

/** Recruiter JDs */
export const RECRUITER_JDS_BASE = "/v1/recruiter/jds";

/** Recruiter Applications */
export const RECRUITER_APPLICATIONS_BASE = "/v1/recruiter/applications";

/** Recruiter Labels */
export const RECRUITER_LABELS_BASE = "/v1/recruiter/labels";

/** Recruiter Verification */
export const RECRUITER_VERIFICATION_BASE = "/v1/recruiter/verification";

/** Recruiter Resume Scores */
export const RECRUITER_RESUME_SCORES_BASE = "/v1/recruiter/resume-scores";

/** Recruiter Dashboard */
export const RECRUITER_DASHBOARD_BASE = "/v1/recruiter/dashboard";

/** Recruiter Users */
export const RECRUITER_USERS_BASE = "/v1/recruiter/users";

/** Recruiter Subscriptions */
export const RECRUITER_SUBSCRIPTIONS_BASE = "/v1/recruiter/subscriptions";

/** Recruiter Transactions */
export const RECRUITER_TRANSACTIONS_BASE = "/v1/recruiter/transactions";

/** Recruiter Reminders */
export const RECRUITER_REMINDERS_BASE = "/v1/recruiter/reminders";

/** Auth endpoints */
export const AUTH_CHANGE_PASSWORD = "/v1/auth/change-password";
export const AUTH_DELETE_USER = "/v1/auth/delete-user";
